/**
 * Overlay da Google Agenda: só tira o que não é compromisso.
 *
 * Working location, e-mail virado evento e aniversário de contacto não são
 * rotina da operação. Idle, intervalo, daily, OOO e tudo o que a pessoa
 * marcou na Agenda entra — no dia certo, mesmo que se repita todo dia.
 */

const SKIP_TYPES = new Set(["workingLocation", "fromGmail", "birthday"]);

export function foldOverlayTitle(title: string): string {
  return title
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\p{Extended_Pictographic}/gu, "")
    .replace(/[\uFE0F\u200D]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

export function isGoogleOverlayNoise(event: {
  eventType?: string | null;
  title?: string | null;
  transparency?: string | null;
  attendees?: Array<string | { email?: string }> | null;
  hangoutLink?: string | null;
}): boolean {
  const type = (event.eventType ?? "").trim();
  if (SKIP_TYPES.has(type)) return true;
  const folded = foldOverlayTitle(event.title ?? "");
  return folded === "" || folded === "(sem titulo)" || folded === "(no title)";
}
